export enum BaseResultStatusEnum {
  OK = 1,
  Warning = 2,
  Error = 0,
  Unreachable = 3,
  Unknown = 4,
  Logout = 5,
}
